import React from 'react';

const THEINFLUENCROOMTheme = {
  headerLogo: {
    src: '/themes/theme/the-influence-room/the-room-small.png',
    alt: 'The Influence Room influencers',
  },
  darkLogo: {
    src: '/themes/theme/the-influence-room/the-room-small.png',
    alt: 'The Influence Room influencers',
  },
  headerStyle: {
    backgroundColor: '#fff',
    borderBottom: '2px solid #0b1919',
  },
  linkStyle: {
    color: '#0b1919',
    fontWeight: 800,
    fontSize: '120%',
  },
  title: 'THE INFLUENCE ROOM | CAMPAIGNS',
  isLightOnDark: false,
  loginMessage: (
    <div style={{ padding: '10px' }}>
      <img height="50" src="/themes/theme/the-influence-room/the-room-small.png" alt="The Room Influencers" />
    </div>
  ),
  shareSite: 'https://reports.theinfluenceroom.com',
  organisationId: '5bf5b36b-48cb-4d2a-a304-580db89965f9',
};

export default THEINFLUENCROOMTheme;



/** WEBPACK FOOTER **
 ** ./src/themes/theme/theinfluenceroom.js
 **/